import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  FormListItem,
  Drawer,
  Panel,
  Margin,
  Text,
  Button,
  Popup,
} from 'shared/components'
import { observer } from 'mobx-react'
import * as styles from './styles'

const DonationsDrawerComponent = ({
  appConfig,
  onClickDownload,
  loadingStates,
  loggedEntity,
  donationYears,
  history,
}) => {
  const { firstName, lastName, address } = loggedEntity

  // More explicit name validation
  const isNameFilled = Boolean(firstName?.trim()) && Boolean(lastName?.trim())

  // More explicit address validation with individual checks
  const hasAddressLine1 = Boolean(address?.address1?.trim())
  const hasCity = Boolean(address?.city?.trim())
  const hasPostalCode = Boolean(address?.zip?.toString().trim())
  const hasCountry = Boolean(address?.country?.trim())

  const isAddressFilled = hasAddressLine1 && hasCity && hasPostalCode && hasCountry

  const listOfReceipts = donationYears.map((year) => {
    const buttons = (
      <div css={styles.buttonGroup}>
        <Button
          small
          primary
          loading={loadingStates[year]?.download}
          disabled={!isAddressFilled || loadingStates[year]?.download}
          onClick={(e) => {
            e.stopPropagation()
            onClickDownload(year)
          }}
        >
          Download PDF
        </Button>
        <Button
          small
          primary
          loading={loadingStates[year]?.email}
          disabled={!isAddressFilled || loadingStates[year]?.email}
          onClick={(e) => {
            e.stopPropagation()
            onClickDownload(year, true)
          }}
        >
          Request Email
        </Button>
      </div>
    )

    return (
      <FormListItem
        css={styles.row}
        key={year}
        title={`${year}`}
        icon={
          !isAddressFilled ? (
            <Popup useAsTooltip trigger={buttons}>
              <div css={styles.tooltip}>
                <Text white size={11}>Add Address in your Personal information to download or request by email your donation receipts.</Text>
              </div>
            </Popup>
          ) : (
            buttons
          )
        }
      />
    )
  })

  const handleDonationReceiptsClick = () => {
    // Check if mobile (phones breakpoint: 767px)
    const isMobile = window.innerWidth <= 767

    if (isMobile) {
      // Mobile: Navigate to new page
      history.push('/profile/donation-receipts')
    } else {
      // Desktop/Tablet: Open drawer
      appConfig.toggleDrawer('donationReceipts')
    }
  }

  return (
    <>
      <FormListItem
        title="Donation Receipts"
        onClick={handleDonationReceiptsClick}
      />
      <Drawer
        isActive={appConfig.drawerState === 'donationReceipts'}
        hideDrawer={() => appConfig.toggleDrawer('')}
      >
        {appConfig.drawerState === 'donationReceipts' && (
          <Panel onClick={() => { }} css={styles.formWrapper}>
            <div>
              <Margin
                as={Text}
                right={1}
                size={18}
                bold
                italic
                bottom={5}
                block
              >
                Donation Receipts
              </Margin>
              {donationYears.length > 0 ? (
                <>
                  <Margin as={Text} right={1} bottom={5} block size={11}>
                    Complete Personal Information to access detailed donation
                    receipts and download them easily
                  </Margin>
                  {listOfReceipts}
                </>
              ) : (
                <Margin as={Text} right={1} bottom={5} block size={11}>
                  You don't have any donation receipts yet. Play InWins to make donations.
                </Margin>
              )}
            </div>
          </Panel>
        )}
      </Drawer>
    </>
  )
}

DonationsDrawerComponent.propTypes = {
  appConfig: PropTypes.shape(),
  loggedEntity: PropTypes.shape(),
  loadingStates: PropTypes.objectOf(PropTypes.shape({
    download: PropTypes.bool,
    email: PropTypes.bool
  })),
  onClickDownload: PropTypes.func,
  donationYears: PropTypes.arrayOf(PropTypes.number),
  history: PropTypes.shape(),
}

DonationsDrawerComponent.defaultProps = {
  donationYears: [],
}

export default observer(DonationsDrawerComponent)
